var _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestaurant03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 265,
    viewBox: "0 0 351 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.753906,
    y: 0.0117188,
    width: 350,
    height: 264,
    fill: "#4A5294"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.369,
    cy: 134.384,
    r: 68.6148,
    fill: "#522D12"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.256,
    cy: 132.721,
    r: 65.4985,
    fill: "#FFFBF8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.312,
    cy: 132.722,
    r: 43.1793,
    fill: "#FFFBF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.312 89.543C221.465 89.543 202.133 108.875 202.133 132.722C202.133 139.424 203.659 145.769 206.384 151.428C197.913 113.416 238.47 79.8516 276.603 102.967C268.737 94.6979 257.626 89.543 245.312 89.543Z",
    fill: "#EBE3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.205 152.901C279.999 148.107 280.719 142.855 283.463 138.919C287.22 133.528 289.435 126.9 289.435 119.736C289.435 101.65 275.321 86.9883 257.91 86.9883C240.499 86.9883 226.385 101.65 226.385 119.736C226.385 130.445 231.333 139.953 238.984 145.928C241.297 147.734 242.455 150.719 242.455 153.653C242.455 163.617 250.909 171.695 261.338 171.695C271.767 171.695 280.221 163.617 280.221 153.653C280.221 153.401 280.216 153.15 280.205 152.901Z",
    fill: "#ECDACD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.506 151.846C278.3 147.053 279.02 141.801 281.763 137.864C285.521 132.473 287.736 125.846 287.736 118.681C287.736 100.595 273.621 85.9336 256.211 85.9336C238.8 85.9336 224.686 100.595 224.686 118.681C224.686 129.39 229.634 138.898 237.285 144.874C239.597 146.679 240.756 149.664 240.756 152.599C240.756 162.562 249.21 170.64 259.639 170.64C270.068 170.64 278.522 162.562 278.522 152.599C278.522 152.347 278.516 152.096 278.506 151.846Z",
    fill: "#FFF2E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.209,
    cy: 112.479,
    r: 14.3342,
    fill: "#FFA462"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.209 126.813C264.126 126.813 270.543 120.395 270.543 112.479C270.543 110.046 269.937 107.755 268.868 105.748C270.521 112.465 269.482 125.963 252.104 126.216C253.404 126.605 254.782 126.813 256.209 126.813Z",
    fill: "#C47740"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.36 102.297C250.646 102.976 246.721 106.846 245.925 112.867C245.851 113.427 245.324 113.829 244.771 113.713C244.34 113.622 244.028 113.241 244.052 112.801C244.426 106.158 249.69 100.822 256.303 100.337C256.845 100.297 257.288 100.742 257.288 101.286C257.288 101.808 256.878 102.235 256.36 102.297Z",
    fill: "#FFD0AE",
    fillOpacity: 0.94
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.431 92.3307C240.666 94.3089 234.446 100.758 232.571 106.687C232.374 107.31 231.699 107.677 231.088 107.443C230.584 107.249 230.301 106.71 230.458 106.194C232.654 98.9796 239.182 92.8975 245.948 90.518C246.299 90.3948 246.686 90.5128 246.918 90.8021C247.338 91.3231 247.063 92.1136 246.431 92.3307Z",
    fill: "#FFFBF9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant03);
export default __webpack_public_path__ + "static/media/restaurant_03.af16c50969971ad729b7010a5d5c3434.svg";
export { ForwardRef as ReactComponent };